export class FollowUpVisitModel {
patientcode = '' ;
visverial = 1;
visdate = '2022-01-01' ;
vistype = '' ;
visservice = '';
visdiganosis = '' ;
visdoctor = '' ;
vislocation = '' ;
viscomplaint = '' ;
visreqinvistigation = '' ;
visweight = '' ;
visbp = '' ;
vispuls = '' ;
visexamination = '' ;
visdiseasestatus = '' ;
vissite = '' ;
visstage = '' ;
visgrade = '' ;
vist = '' ;
visn = '' ;
vism = '' ;
visstatus = '' ;
visdecision = '' ;
vistttpolicy = '' ;
visnextdate = '2022-01-01';
visnextaction = '' ;
visnotes = '' ;
vispresenthistory = '' ;
vissurgerytype = '' ;
vissurgerynotes = '' ;
visradiotype = '' ;
visradiodose = '' ;
visradionotes = '' ;
vischemotype = '' ;
vischemocycle = '' ;
vischemonotes = '' ;
vishormonaltype = '' ;
vishormonalduration = '' ;
vishormonalnotes = '' ;
visotherstype = '' ;

compcode = '' ;
userid = '' ;
modifieddate = '2022-01-01';

}

